import { render, staticRenderFns } from "./ResourceAttachmentTypePicker.vue?vue&type=template&id=7e95acd8"
import script from "./ResourceAttachmentTypePicker.vue?vue&type=script&lang=js"
export * from "./ResourceAttachmentTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports